export default __webpack_public_path__ + "static/media/1_0148.17cf13a7.webp";